// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const ASPECT_RATIO = 16 / 9
export const MOBILE_MAX_WIDTH = 400

export const UNKNOWN_ID = 'unknown'
export const UNKNOWN_NUMBER_ID = -1
